import CheckIcon from '@mui/icons-material/Check';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { activateManual } from '../../../api/subscriptions';
import clientConfig from '../../../client-config';

export default function AllOrders() {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState('');
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  useEffect(() => {
    fetch(`${clientConfig.backendHOST}/subscriptions/All`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-auth-token': localStorage.token,
      },
    })
      .then((res) => res.json())
      .then((data) => setOrders(data));
  }, []);

  const handleActivate = (id) => {
    activateManual(id).then(() => {
      setOrders((prev) =>
        prev.map((order) =>
          order.id === id ? { ...order, requestStatus: 'Aktivált' } : order
        )
      );
    });
  };

  useEffect(() => {
    const filtered = orders.filter((order) =>
      `${order.user?.firstName} ${order.user?.lastName}`
        .toLowerCase()
        .includes(search.toLowerCase())
    );
    setFilteredOrders(filtered);
    setPage(0); // Reset page on search
  }, [orders, search]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedOrders = filteredOrders.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box
      className='content-block'
      maxWidth={'lg'}
      sx={{
        mx: 'auto',
        mt: 4,
        mb: 4,
        p: 2,
        alignItems: 'center',
      }}
    >
      <Paper elevation={3} sx={{ p: 3, mb: 2 }}>
        <Typography variant='h5' gutterBottom>
          Megrendelések szerkesztése
        </Typography>
        <TextField
          placeholder='Keresés...'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TableContainer>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Vezetéknév</TableCell>
                <TableCell>Keresztnév</TableCell>
                <TableCell>Előfizetés kódja</TableCell>
                <TableCell>Előfizetés</TableCell>
                <TableCell>Létrehozás dátuma</TableCell>
                <TableCell>Fizetési mód</TableCell>
                <TableCell>Állapot</TableCell>
                <TableCell>Művelet</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedOrders.map((order) => (
                <TableRow key={order.id}>
                  <TableCell>{order.user?.lastName}</TableCell>
                  <TableCell>{order.user?.firstName}</TableCell>
                  <TableCell>{order.subscription_code}</TableCell>
                  <TableCell>
                    {order.subscription_prices?.[0]?.price_details}
                  </TableCell>
                  <TableCell>
                    {new Date(order.created_at).toLocaleDateString()}
                  </TableCell>
                  <TableCell>{order.PaymentMethod}</TableCell>
                  <TableCell>{order.requestStatus}</TableCell>
                  <TableCell>
                    {order.requestStatus === 'Nyitott' && (
                      <IconButton onClick={() => handleActivate(order.id)}>
                        <CheckIcon color='success' />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component='div'
          count={filteredOrders.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
      </Paper>
    </Box>
  );
}
